import React, {FC} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {AppPanelId} from '../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {Banner, BannerTypesEnum} from '../../../../../libs/shared/ui/src/components/banners/banner';
import {BannerAction} from '../../../../../libs/shared/ui/src/components/banners/bannerAction';
import {BannerIcon} from '../../../../../libs/shared/ui/src/components/banners/bannerIcon';
import {BannerPrioritiesEnum} from '../../../../../libs/shared/ui/src/components/banners/bannersContext';
import {BannerText} from '../../../../../libs/shared/ui/src/components/banners/bannerText';
import {useAppDispatch} from '../../../../helpers/appReduxHelpers';
import {LinkedConversationsUndoBannerState} from '../../../../store/panels/app/banners/bannersState';
import {undoLinkedConversationsBannerAction} from '../../../../store/panels/app/banners/linkedConversationsUndoBannersActions';

/*
 * Props.
 */

interface LinkedConversationsUndoBannerProps {
  panelId: AppPanelId;
  state: LinkedConversationsUndoBannerState;
}

/*
 * Component.
 */

export const LinkedConversationsUndoBanner: FC<LinkedConversationsUndoBannerProps> = ({panelId, state}) => {
  const dispatch = useAppDispatch();
  const onUndoClick = () => {
    dispatch(undoLinkedConversationsBannerAction(panelId, state));
  };

  return (
    <Banner bannerType={BannerTypesEnum.INLINE} priority={BannerPrioritiesEnum.TRANSIENT}>
      <BannerIcon iconName="linkedConversationsFilledSmall" />
      <BannerText>
        <Trans id="linked-conversations-undo-banner-text">Linked to</Trans> &quot;
        {state.originalConversation.subject}&quot;
      </BannerText>
      <BannerAction onClick={onUndoClick}>
        <Trans id="linked-conversations-undo-banner-undo">Undo</Trans>
      </BannerAction>
    </Banner>
  );
};
